module.exports = __webpack_public_path__ + "static/media/hamburger.fca17319.jpeg";